export default __webpack_public_path__ + "static/media/e.040d7740.svg";